import React, { useState, useEffect, useLayoutEffect, useRef } from 'react';
import { useStore } from "react-redux";
import { Button } from '../components/atoms/button';
import { useHistory } from "react-router-dom";
import useMedia from "use-media";
import '../resources/css/login/login.css';
import Const from '../const/Const';

export const MembershipLoginCheck = (props) => {
    const history = useHistory();
    const [kaiinkenFlg, setKaiinkenFlg] = useState(false);
    const store = useStore();

    //画面読み込み時に1度だけしか実行させない
    useLayoutEffect(() => {
        const state = store.getState().login;
        const resvKaiinken = store.getState().resvKaiinken;
        console.log(Object.keys(state).length);
        if (Object.keys(state).length === 0) {
            setKaiinkenFlg(true);
            return;
        }
        if (resvKaiinken && resvKaiinken.length > 0) {
            resvKaiinken.forEach(value => {
                if (value.keiyakuNo == Const.GENERAL_CONTRACT_NO) {
                    setKaiinkenFlg(true);
                }
            });
        }
    }, []);

    //ログアウト処理
    const logoutClick = () => {
        history.push("/reserve/top");
    };

    return (
        <div>
            {kaiinkenFlg ?
                <div className='modalBody'>
                    <div className='modalContent'>
                        <div className='modalArea'>
                            <div>
                                <div className='modalText'>
                                    申し訳ございません。こちらはホテル会員権所有者限定のメニューとなります。<br></br>
                                    会員権をお持ちの方はひも付け登録をされるか、RTTGアプリ事務局（052-300-8666）までご連絡ください。
                                </div>
                                <div className='modalBtnArea'>
                                    <Button
                                        onClick={logoutClick}
                                        buttonText={"TOP画面へ"}
                                        className="logoutBtn"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                : null
            }
        </div>
    )
}